import { get } from 'lodash';
import moment from 'moment/moment';
import { SELECT_ALL_VALUE } from '../constants';
import { Filter } from '../Filters/types';

export function searchFilterByColumn<TableEntity>(
  filter: Filter<TableEntity, string | string[] | moment.Moment>,
  row: TableEntity
): boolean {
  if (moment.isMoment(filter.value)) {
    if (!filter.value) return true;
    const cellDate = moment(row[filter.id] as string);
    return cellDate.isSame(filter.value, 'day');
  }

  if (typeof filter.value === 'string') {
    return get(row, filter.id, '').toString().includes(filter.value);
  }

  const selectedValues = filter.value || [];

  if (!selectedValues.length) return true;

  if (selectedValues.includes(SELECT_ALL_VALUE)) return true;

  return selectedValues.includes(get(row, filter.id));
}

export function searchFilterFoTable<TableEntity>(data: TableEntity[], filters: Filter<TableEntity>[]) {
  return filters.reduce(
    (filteredData: TableEntity[], filter: Filter<TableEntity>) =>
      filteredData.filter(row => searchFilterByColumn(filter, row)),
    data
  );
}
